export default __webpack_public_path__ + "static/media/404_logo.b2fc41b3.svg";